// src/utils/communityAccess.js

export const COMMUNITY_MASK = {

    REBEL_KALP: 1,

    DREAM_KALP: 2,

    BUILD_KALP: 4,
 
    GROW_KALP: 8,

    FLOW_KALP: 16

};

export function getAccessMask() {

    return Number(

        localStorage.getItem("access_mask") || 0

    );

}

export function hasCommunityAccess(category) {

    const userMask = getAccessMask();

    const categoryMask = COMMUNITY_MASK[category];

    if (!categoryMask) {

        return false;

    }

    return (userMask & categoryMask) !== 0;

}

export function getUnlockedCommunities() {

    const userMask = getAccessMask();

    return Object.keys(COMMUNITY_MASK)

        .filter(category =>

            (userMask & COMMUNITY_MASK[category]) !== 0

        );

}